[
	{
		"header": "Order Date time",
		"field": "dateRange",
		"datatype": "DateTime",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Side",
		"field": "buySellCode",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "B-(buy)",
				"value": "B"
			},
			{
				"label": "SL-(sell long)",
				"value": "SL"
			},
			{
				"label": "SS-(short sale)",
				"value": "SS"
			},
			{
				"label": "SX-(short sale exempt)",
				"value": "SX"
			}
		]
	},
	{
		"header": "Branch Seq No",
		"field": "branchSeqNum",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "sent To Firm MPID",
		"field": "sentToFirmMpid",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "order Sent Timestamp",
		"field": "orderSentTimestamp",
		"datatype": "DateTime",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "routed Shares Qty",
		"field": "routedSharesQty",
		"datatype": "Int",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "routing Method Code",
		"field": "routingMethodCode",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "E-(Electronic)",
				"value": "E"
			},
			{
				"label": "N-(Non-Electronic)",
				"value": "N"
			},
			{
				"label": "S-(Smart Router)",
				"value": "S"
			},
			{
				"label": "F-(NYSE Floor Broker Algorithm)",
				"value": "F"
			}
		]
	},
	{
		"header": "special Routing Condition",
		"field": "specialRoutingCondition",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "‘X’ (Exchange Order Modification)",
				"value": "X"
			},
			{
				"label": "‘Y’ (Bunched Order)",
				"value": "Y"
			}
		]
	},
	{
		"header": "destination Code",
		"field": "destinationCode",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "‘A’(Reportable Non-Member; Affiliate)",
				"value": "A"
			},
			{
				"label": "‘E’(ECN)",
				"value": "E"
			},
			{
				"label": "‘M’(FINRA Member)",
				"value": "M"
			},
			{
				"label": "‘N’(Reportable Non-Member ,Not an Affiliate) ",
				"value": "N"
			},
			{
				"label": "‘F’ (Foreign Affiliate)",
				"value": "F"
			},
			{
				"label": "‘X’ (Foreign BD,not an Affiliate).",
				"value": "X"
			},
			{
				"label": "‘XA’ (NYSE American)",
				"value": "XA"
			},
			{
				"label": "‘XB’ (Nasdaq BX)",
				"value": "XB"
			},
			{
				"label": "‘XC’ (NYSE National Stock Exchange4)",
				"value": "XC"
			},
			{
				"label": "‘XF’ (Non-US Exchange)",
				"value": "XF"
			},
			{
				"label": "‘XI’ (International Securities Exchange)",
				"value": "XI"
			},
			{
				"label": "‘XJ’ (CBOE EDGA Exchange)",
				"value": "XJ"
			},
			{
				"label": "‘XK’ (CBOE EDGX Exchange)",
				"value": "XK"
			},
			{
				"label": "‘XM’ (Chicago Stock Exchange)",
				"value": "XM"
			},
			{
				"label": "‘XN’ (New York Stock Exchange)",
				"value": "XN"
			},
			{
				"label": "‘XO’ (Bourse de Montreal)",
				"value": "XO"
			},
			{
				"label": "‘XP’ (NYSE Arca)",
				"value": "XP"
			},
			{
				"label": "‘XQ’ (The Nasdaq Stock Market)",
				"value": "XQ"
			},
			{
				"label": "‘XT’ (Toronto Stock Exchange)",
				"value": "XT"
			},
			{
				"label": "‘XV’ (Investors Exchange)",
				"value": "XV"
			},
			{
				"label": "‘XW’ (CBOE Stock Exchange)",
				"value": "XW"
			},
			{
				"label": "‘XX’ (Nasdaq PHLX)",
				"value": "XX"
			},
			{
				"label": "‘XY’ (CBOE BYX Exchange)",
				"value": "XY"
			},
			{
				"label": "‘XZ’ (CBOE BZX Exchange)",
				"value": "XZ"
			},
			{
				"label": "‘OA’(NYSE American Options Exchange)",
				"value": "OA"
			},
			{
				"label": "‘OB’(Boston Options Exchange, LLC)",
				"value": "OB"
			},
			{
				"label": "‘OC’(Chicago Board Options Exchange)",
				"value": "OC"
			},
			{
				"label": "‘OK’(CBOE EDGX Options Exchange)",
				"value": "OK"
			},
			{
				"label": "‘OH’ (ISE Gemini)",
				"value": "OH"
			},
			{
				"label": "‘OI’(International Securities Exchange)",
				"value": "OI"
			},
			{
				"label": "‘OJ’(C2 Options Exchange)",
				"value": "OJ"
			},
			{
				"label": "‘OM’ (MIAX Options Exchange)",
				"value": "OM"
			},
			{
				"label": "‘OP’(NYSE Arca Options Exchange)",
				"value": "OP"
			},
			{
				"label": "‘OQ’(Nasdaq Options)",
				"value": "OQ"
			},
			{
				"label": "‘OS’ (MIAX Pearl LLC)",
				"value": "OS"
			},
			{
				"label": "‘OT’ (Nasdaq BX Options)",
				"value": "OT"
			},
			{
				"label": "‘OX’(Nasdaq PHLX Options)",
				"value": "OX"
			},
			{
				"label": "‘OY’ (ISE Mercury) ",
				"value": "OY"
			},
			{
				"label": "‘OZ’(CBOE BZX Options Exchange)",
				"value": "OZ"
			}
		]
	},
	{
		"header": "routed Order Type Indicator",
		"field": "routedOrderTypeIndicator",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "L-(Order Routed as a Limit Order)",
				"value": "L"
			},
			{
				"label": "M-(Order Routed as a Market Order)",
				"value": "M"
			}
		]
	},
	{
		"header": "route Price",
		"field": "routePrice",
		"datatype": "Float",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "iso Indicator",
		"field": "isoIndicator",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "Y",
				"value": "Y"
			},
			{
				"label": "T",
				"value": "T"
			}
		]
	},
	{
		"header": "short Sale Exempt Indicator",
		"field": "shortSaleExemptIndicator",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "participation Flag",
		"field": "participationFlag",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "connection ID",
		"field": "connectionID",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Routed Order ID",
		"field": "routedOrderID",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Sent TO Routed Order ID",
		"field": "sentToRoutedOrderID",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Record Type",
		"field": "recordType",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Firm ROE ID",
		"field": "firmRoeID",
		"datatype": "Int",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Correction Deletion Timestamp",
		"field": "correctionDeletionTimestamp",
		"datatype": "DateTime",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Resubmit",
		"field": "resubmit",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "Y-(yes)",
				"value": "Y"
			}
		]
	},
	{
		"header": "Order Receiving Date",
		"field": "orderReceivingDate",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Firm Order ID",
		"field": "firmOrderID",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	}
]